import FileAttachmentGroup, {
	FileAttachmentGroupProps,
} from '@/components/Attachment/FileAttachmentGroup'
import {
	AttachmentType,
	type Attachment,
	type FileAttachment as FileAttachmentType,
	type LinkAttachment as LinkAttachmentType,
} from '@/utils/fetchers/attachment'
import clsx from 'clsx'
import { first, isEmpty } from 'lodash-es'
import { AnimatePresence } from 'motion/react'
import styles from './AttachmentsPreview.module.css'
import LinkAttachment, { LinkAttachmentProps } from './LinkAttachment'

export interface AttachmentsPreviewProps extends Omit<FileAttachmentGroupProps, 'data'> {
	data: Attachment[]
}

/**
 * 附件预览组件
 * 需要在 FormProvider 之内使用
 */
export default function AttachmentsPreview({
	data,
	onDelete,
	onSwap,
	onRetry,
	className,
	...props
}: AttachmentsPreviewProps) {
	const renderAttachments = () => {
		if (isEmpty(data)) {
			return null
		}

		if (first(data)?.type === AttachmentType.LINK) {
			const maybeFileAttachmentData = first(data) as LinkAttachmentType

			return (
				<LinkAttachment
					{...(props as LinkAttachmentProps)}
					className={clsx(styles.linkAttachment, className)}
					data={maybeFileAttachmentData}
					onDelete={() => onDelete?.(maybeFileAttachmentData.id)}
				/>
			)
		}

		return (
			<FileAttachmentGroup
				{...(props as FileAttachmentGroupProps)}
				className={clsx(styles.fileAttachmentGroup, className)}
				data={data as FileAttachmentType[]}
				onDelete={onDelete}
				onSwap={onSwap}
				onRetry={onRetry}
			/>
		)
	}

	return <AnimatePresence>{renderAttachments()}</AnimatePresence>
}
